import { STORAGE_KEYS } from '@/shared/constants/storage-keys';
import { localStorageUtil } from '@/shared/utils/local-storage';
import type { LoginPlan } from '@/modules/auth/types';

/**
 * Persists the tenant's current plan in localStorage so a page refresh
 * doesn't blank out plan-gated UI (limits, feature flags, badges).
 *
 * The plan is also primed into the TanStack Query cache under
 * `planCacheKeys.current()` on login; this util is the durable mirror that
 * hydrates the cache on next page load.
 */

export function setStoredPlan(plan: LoginPlan | null): void {
    localStorageUtil.set(STORAGE_KEYS.PLAN, plan);
}

export function readStoredPlan(): LoginPlan | null {
    return localStorageUtil.get<LoginPlan | null>(STORAGE_KEYS.PLAN);
}

export function clearStoredPlan(): void {
    localStorageUtil.remove(STORAGE_KEYS.PLAN);
}
